<template>
	<v-touch class="frame">
		<div class="container-box">
			<!-- 顶部 -->
			<div class="header">
				<div class="headerFrame">
					<tabBar></tabBar>
				</div>
			</div>
			<!-- 内容 -->
			<div class="content">
				<div>
					<carousel :items="banners"></carousel>
				</div>
				<!-- 山哩商城 -->
				<div style="margin-top: 10px;">
					<video id="myVideo" class="video-js" style="object-fit: contain;">
						<source src="https://slkjkg.com/video/jieshao.mp4" type="video/mp4">
					</video>
				</div>
				<div class="shoppingMall">
					<div class="mg dt" v-for="(title,index) in article" :key="index" @click="clickBg(title.titleUrl)">
						<div class="shoppingMallBg">
							<img :src="title.fileList[0].filePath" class="imgStyle" />
						</div>
						<div class="serverFrame" :style="{backgroundColor: title.titleBackgroundColor}">
							<div class="serverFrameFont">
								<div class="serverFrameTime"
									:style="{color:title.titleTextColor,borderColor:title.titleTextColor}">
									<div style="transform: skew(0deg);">
										{{title.titleRemark}}
									</div>
								</div>
								<div class="serverFrameTitle" :style="{color:title.titleTextColor}">
									<span>{{title.titleName}}</span>
								</div>
								<div class="serverFrameContent" :style="{color:title.titleTextColor}">
									<div>
										<span>{{title.titleContent}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<fixedBottomRight></fixedBottomRight>
				<div class="animation dt"
					style="padding-top: 20px; padding-bottom: 20px; background-color: #840000; color: white; padding-left: 40px; padding-right: 20px; font-size: 1.6rem; margin-top: 30px;text-align: center;">
					<div style="margin-top: 5px;">服务民生，刚性需求！为更智慧更便民更优质</div>
					<div style="margin-top: 5px;">更美好的生活而努力，山里的就是好！</div>
				</div>
				<div class="animation dt" style="padding-left: 40px; padding-right: 20px; color: #8497a7;">
					版权所有：山哩数智科技有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">黔ICP备2022006061号</a> |
					软著登字第10483538 | 电信经营许可编号：黔B120200042
				</div>
			</div>
		</div>
	</v-touch>
</template>

<script>
	import tabBar from "@/assembly/tabBarNew.vue";
	import swiper from "@/assembly/mobileSwiper.vue";
	import carousel from '@/assembly/carousels.vue';
	import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
	import {
		getHome
	} from "../../api/home.js"
	export default {
		name: "index",
		data() {
			return {
				tabBarTitle: "新消费智慧供应链生态运营平台",
				tabBarTitle1: "专业化 精细化 特色化 新颖化",
				premiumService: "线上App平台为依托, 探索集成式便民新零售发展路线,",
				premiumService1: "在全国范围布局山哩优品生活服务店",
				farmFrameChildFont: "投资零售和消费品家庭农场作坊, 助力农村经济发展,解决农民就业;同时打造自有品牌、完善自身供应链体系.",
				businessFooterFontContent: "通过商学院联盟, 实现",
				businessFooterFontContent1: "'共创、共享、共生，让事业无边界'",
				show1: false, // 定义第一个div的数据
				show2: false, // 定义第二个div的数据
				show3: false,
				currentIndex: -1,
				banners: [],
				article: [],
			};
		},
		created() {
			// 首页
			let modelId = 5;
			var banners = [];
			var article = [];
			var that = this;
			getHome({
				modelId
			}).then((res) => {
				if (res.code == 200 && res.data.length > 0) {

					res.data.forEach((item) => {
						if (item.titleType == 0) { //文章
							banners.push(item)
						}
						if (item.titleType == 1) { //轮播图
							article.push(item)
						}
					})
					console.log(article)
					that.article = article;
					that.banners = banners;
				}
			})
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll); // 在挂载后监听滚动事件
			this.initVideo();
		},
		beforeDestroy() {
			window.removeEventListener("scroll", this.handleScroll); // 在销毁前移除滚动事件
		},
		components: {
			tabBar,
			swiper,
			carousel,
			fixedBottomRight
		},
		methods: {
			clickbj1() {
				this.$router.push({
					name: url
				})
			},
			handleScroll() { // 定义一个方法，用于判断元素是否进入可视区域
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // 获取滚动距离
				let elements = document.querySelectorAll('.dt');
				elements.forEach(div => { // 遍历数组中的每个对象
					let offsetTop = div.offsetTop; // 获取元素距离顶部的位置
					let threshold = 0; // 获取元素对应的阈值
					if (scrollTop + window.innerHeight > offsetTop + threshold) { // 判断元素是否进入可视区域
						if (div.classList.contains('animation') == false) { //不存在动画类，则添加
							div.classList.add('animation')
						}
					} else {
						div.classList.remove('animation')
					}
				})
			},
			blackDivClick(e) {
				let btn2 = e.currentTarget.previousElementSibling;
				btn2.classList.add("active"); // 给按钮元素添加一个active类名
			},
			shadeClick(e) {
				let btn = e.currentTarget;
				btn.classList.remove("active"); // 给按钮元素添加一个active类名
			},
			arrowClick(url) {
				this.$router.push({
					name: url
				})
			},
			initVideo() {
				//初始化视频方法
				let myPlayer = this.$video(myVideo, {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					//自动播放属性,muted:静音播放
					/* autoplay: "muted", */
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					//设置视频播放器的显示宽度（以像素为单位）
					/* width: "100%",
					//设置视频播放器的显示高度（以像素为单位）
					height: "300px", */
					poster: require('../../assets/bg1.png')
				});
			},
			clickBg(url) {
				window.location.href = url;
			},
			replice(path) {

				return path.replice('shanliguanwang.oss-cn-hangzhou.aliyuncs.com', 'slkjkg.com');
			}
		}
	};
</script>

<style lang="scss" scoped>
	@keyframes moveUp {
		from {
			transform: translateY(100%);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	.frame {
		position: absolute;
		height: 100%;
		width: 100%;
		touch-action: pan-y !important;
	}

	.container-box {
		display: flex;
		flex-direction: column;


		.imgStyle {
			height: 100%;
			width: 100%;
		}

		.header {
			z-index: 999;
			top: 0;
			position: fixed;
			background-color: #fff;
			-webkit-transform: translateZ(0);
			opacity: 0.85;

			.headerFrame {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: 7.5vh;
				width: 100vw;
			}

			.headerChild {
				height: 59%;
				width: 100vw;
			}


		}

		.content {
			display: flex;
			flex-direction: column;
			margin-top: 7.5vh;
			width: 100vw;

			// 山哩商城
			.shoppingMall {
				display: flex;
				flex-direction: column;
				padding-left: 20px;
				padding-right: 20px;

				.shoppingMallBg {
					height: 28vh;
				}

				.diagram {
					top: -5rem;
					position: relative;
					width: 80%;
				}

				.shoppingMallContent {
					margin-top: 0.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					background-color: #840000;
					color: #fff;

					.contentChild {
						top: 0rem;
						position: relative;
						height: 50%;
						display: flex;
						flex-direction: column;
						align-items: center;

						.contentFontFrame {
							font-weight: bold;
							padding: 0.5rem;
							border-bottom: solid 2px;
							font-size: 1.2rem;
						}

						.contentFontFrame1 {
							padding-top: 1rem;
							font-size: 0.9rem;
						}

						.contentFontFrame2 {
							font-size: 0.9rem;
						}

						.contentCode {
							margin: 1rem;
							width: 100%;
						}
					}
				}
			}

			// 服务店
			.serverFrame {
				/* margin-top: 1rem; */
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 100%;
				background-color: #840000;
				/* height: 35vh; */
				overflow: hidden;

				.serverFrameFont {
					margin: 0.5rem 2rem;
					height: 30%;
					display: flex;
					flex-direction: column;
					align-items: center;
					color: #fff;

					.serverFrameTime {
						position: relative;
						left: -148px;
						width: 180px;
						height: 30px;
						border-top: 1px solid white;
						border-bottom: 1px solid white;
						border-right: 1px solid white;
						-webkit-transform: skew(-20deg);
						transform: skew(-20deg);
						margin-top: 15px;
						margin-bottom: 10px;
						text-align: end;
						padding-right: 17px;
						line-height: 30px;
						font-size: 15px;
						font-weight: 600;
					}

					.serverFrameTitle {
						font-weight: bold;
						font-size: 18px;
						/* border-bottom: solid 2px #fff; */
						position: relative;
						/* left: -129px; */
						width: 100%;
					}

					.serverFrameContent {
						padding-top: 2rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						font-size: 16px;
						margin-bottom: 25px;
					}
				}

				.serverFrameImg {
					margin-bottom: 1rem;
					height: 70%;
					width: 100%;
				}
			}

			// 农场
			.farmFrame {
				margin-top: 1rem;
				height: 60vh;
				display: flex;
				flex-direction: column;

				.farmFrameChild {
					height: 40%;
					width: 100%;
				}

				.farmFrameChild1 {
					margin-top: 2%;
					height: 58%;
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;

					.farmFrameChildImg {
						display: flex;
						justify-content: space-between;
						height: 50%;
						width: 96%;
						position: relative;
						top: 1rem;

						.farmFrameChildImg1 {
							height: 100%;
							width: 48%;
						}
					}

					.farmFrameChildContent {
						padding-top: 1rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						height: 50%;
						width: 100%;
						background-color: #840000;
						color: #fff;

						.farmChildFrame {
							width: 94%;
						}

						.farmChildFont {
							width: 35%;
							padding: 0.5rem;
							font-weight: bold;
							font-size: 1.2rem;
							border-bottom: solid 2px #fff;
						}

						.farmChildFont1 {
							margin-top: 1rem;
							font-size: 0.5rem;
						}
					}
				}
			}

			// 商学院
			.business {
				margin-top: 1rem;
				display: flex;
				flex-direction: column;
				height: 40vh;

				.businessHeader {
					padding: 1rem;
					height: 15%;
					background-color: #840000;
				}

				.businessMiddle {
					display: flex;
					justify-content: center;
					height: 40%;

					.businessMiddleImg {
						top: -1rem;
						position: relative;
						height: 20vh;
						width: 60%;
					}
				}

				.businessFooter {
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					align-items: center;
					height: 45%;
					width: 100%;
					background-color: #840000;

					.businessFooterChild {
						margin-bottom: 3%;
						height: 80%;
						width: 80%;
						color: #fff;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						.businessFooterFont {
							padding: 0.5rem;
							border-bottom: solid 2px;
							font-size: 1.2rem;
							font-weight: bold;
						}

						.businessFooterFont1 {
							margin-top: 0.5rem;
							display: flex;
							flex-direction: column;
							align-items: center;
							font-size: 0.5rem;
						}
					}
				}
			}
		}
	}

	.tabBarFontFrame {
		pointer-events: none;
		color: #fff;
		height: 5vh;
		width: 100%;
		position: absolute;
		top: 17.5vh;
		z-index: 3;
		display: flex;
		align-items: center;
		flex-direction: column;
		animation: moveUp 3s 1;

		.tabBarFont {
			letter-spacing: 2px;
			font-weight: bold;
			font-size: 1.3rem;
		}

		.tabBarFont1 {
			margin-top: 2%;
			font-size: 1rem;
			letter-spacing: 2px;
		}
	}

	.animation {
		position: relative;
		animation: moveUp 3s 1;
	}

	.black-div {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.85);
		/* 设置背景色为半透明的黑色 */
		color: white;
		font-size: 24px;
		text-align: center;
		line-height: 100%;
		display: none;
		z-index: 2;
	}

	.container {
		display: flex;
		/* 设置容器为flex布局 */
		justify-content: center;
		/* 设置水平居中 */
		align-items: center;
		/* 设置垂直居中 */
		padding-top: 15px;
	}

	.circle-div {
		width: 42px;
		/* 设置圆形DIV的宽度 */
		height: 42px;
		/* 设置圆形DIV的高度 */
		border-radius: 50%;
		/* 设置圆形DIV的边框半径为50% */
		background-color: white;
		/* 设置圆形DIV的背景色为绿色 */
		position: relative;
		/* 设置圆形DIV的定位为相对定位 */
	}

	.arrow-img {
		/* 设置图片的样式 */
		width: 54px;
		/* 设置图片的宽度 */
		height: 54px;
		/* 设置图片的高度 */
		position: absolute;
		/* 设置图片的定位为绝对定位 */
		top: 50%;
		/* 设置图片的上偏移为50% */
		left: 50%;
		/* 设置图片的左偏移为50% */
		transform: translate(-50%, -50%);
		/* 使用transform属性调整图片的位置，使其居中 */
	}

	.active {
		display: block;
	}

	.mg {
		margin-top: 30px;
	}

	.shade {
		position: absolute;
		top: 30%;
		width: 100%;
		text-align: center;

		.shade-title {
			font-size: 13px;
			padding-left: 20%;
			padding-right: 20%;
		}

		.shade-line {
			height: 1px;
			width: 62px;
			background: #015198 none repeat scroll 0 0;
			margin: 12px auto 6px;
		}
	}

	.video-js {
		width: 100%;
		height: 232px;
	}

	.video-js video {
		object-fit: contain;
		width: 100%;
		height: 100%;
	}

	.text {
		position: relative;
		top: -40px;
		width: 100%;
		text-align: center;
		font-size: 24px;
		font-weight: 600;
		color: white;
	}
</style>


// WEBPACK FOOTER //
// src/components/iphone/index.vue